'use client';

import { calculatePrice, formatPrice } from '../lib/pricing';

interface Step5Props {
  domain: string;
  selectedEmails: string[];
  onNext: () => void;
  onBack: () => void;
}

export default function Step5Summary({ domain, selectedEmails, onNext, onBack }: Step5Props) {
  const { price, tier, isCustom } = calculatePrice(selectedEmails.length);

  return (
    <div className="animate-fade-in max-w-lg mx-auto">
      <h2 className="text-2xl font-bold mb-2">Récapitulatif</h2>
      <p className="text-muted mb-6">Vérifiez votre configuration avant de continuer.</p>

      <div className="bg-white border border-border rounded-xl overflow-hidden shadow-sm">
        {/* Domain */}
        <div className="px-5 py-4 border-b border-border">
          <p className="text-xs text-muted uppercase tracking-wide mb-1">Domaine choisi</p>
          <p className="font-mono font-semibold text-primary">{domain}</p>
        </div>

        {/* Emails */}
        <div className="px-5 py-4 border-b border-border">
          <p className="text-xs text-muted uppercase tracking-wide mb-2">
            Adresses email ({selectedEmails.length})
          </p>
          <div className="space-y-1.5">
            {selectedEmails.map((prefix) => (
              <div key={prefix} className="flex items-center gap-2">
                <span className="text-success text-sm">&#10003;</span>
                <span className="font-mono text-sm">
                  {prefix}@{domain}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* Pricing tier */}
        <div className="px-5 py-4 border-b border-border">
          <p className="text-xs text-muted uppercase tracking-wide mb-2">Forfait</p>
          <p className="text-sm font-medium">
            {tier
              ? `${tier.label} \u2014 ${formatPrice(tier.price)} / an`
              : isCustom
                ? `Personnalisé (${selectedEmails.length} adresses) \u2014 ${formatPrice(price)} / an`
                : '\u2014'}
          </p>
        </div>

        {/* Included services */}
        <div className="px-5 py-4 border-b border-border">
          <p className="text-xs text-muted uppercase tracking-wide mb-2">Services inclus</p>
          <div className="space-y-1.5 text-sm">
            <div className="flex items-center gap-2">
              <span className="text-success">&#10003;</span>
              <span>Achat et configuration du domaine</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-success">&#10003;</span>
              <span>Configuration DNS compl&egrave;te</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-success">&#10003;</span>
              <span>Cr&eacute;ation des adresses email</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-success">&#10003;</span>
              <span>Assistance installation (PC / Mobile)</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-success">&#10003;</span>
              <span>Support technique inclus</span>
            </div>
          </div>
        </div>

        {/* Price */}
        <div className="px-5 py-5 bg-primary-light/30">
          <div className="flex items-center justify-between">
            <p className="font-medium">Total</p>
            <p className="text-2xl font-bold text-primary">
              {formatPrice(price)}
            </p>
          </div>
          <p className="text-xs text-muted mt-1">Par an &middot; Pas de frais cach&eacute;s</p>
        </div>
      </div>

      <div className="flex gap-3 mt-8">
        <button
          onClick={onBack}
          className="px-6 py-3 rounded-lg border border-border text-muted hover:bg-gray-50 transition-colors cursor-pointer"
        >
          Retour
        </button>
        <button
          onClick={onNext}
          className="flex-1 bg-primary hover:bg-primary-hover text-white font-semibold py-3 rounded-lg transition-colors cursor-pointer"
        >
          Activer mes emails professionnels
        </button>
      </div>
    </div>
  );
}